<template>
  <div class="site-page site-page--wide nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">帮助中心</h1>
      <el-row :gutter="16" class="site-page__grid-row">
        <el-col
          v-for="(section, index) in helpSections"
          :key="index"
          :xs="24"
          :sm="12"
          :md="8"
        >
          <el-card class="site-page__help-card" shadow="hover">
            <div class="site-page__help-icon">
              <el-icon :size="40">
                <component :is="section.icon" />
              </el-icon>
            </div>
            <h3>{{ section.title }}</h3>
            <p>{{ section.description }}</p>
            <el-button type="primary" plain @click="navigateTo(section.route)">
              了解更多
            </el-button>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { QuestionFilled, Setting, Document, Notebook } from '@element-plus/icons-vue'

export default {
  name: 'HelpView',
  components: {
    QuestionFilled,
    Setting,
    Document,
    Notebook
  },
  data() {
    return {
      helpSections: [
        {
          title: '快速入门',
          description: '了解如何注册、完善资料并开始使用平台核心功能。',
          icon: 'QuestionFilled',
          route: '/faq'
        },
        {
          title: '账户与安全',
          description: '修改个人信息、密码，以及账户相关常见问题。',
          icon: 'Setting',
          route: '/user/info'
        },
        {
          title: '内容与测评',
          description: '发布编辑推荐、参与心智测试与查看结果的说明。',
          icon: 'Document',
          route: '/blogs'
        },
        {
          title: '产品设计文档',
          description: '站内浏览全部产品设计 HTML（登录、推荐券、测评 JSON、安全报告等）。',
          icon: 'Notebook',
          route: '/design'
        }
      ]
    }
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route)
    }
  }
}
</script>
